module.exports = __webpack_public_path__ + "static/media/coronavirus.db36a2d9.png";